import styled from "styled-components"
import { device } from "breakpoints"
import { getGradient } from "helpers/getGradient"
import { getSolidColor } from "../../utils/helpers/getSolidColor"

export const StepByStepContainer = styled.div`
  margin: 30px 0;

  @media ${device.desktop} {
    margin: 50px 0;
  }
  ol {
    display: flex;
    list-style-type: none;
    flex-direction: column;
  }
`

export const Step = styled.li`
  border-top: 1px solid #d2d4e0;
  padding: 34px 0 40px 40px;
  display: flex;
  flex-direction: column;
  list-style-type: none;
  position: relative;
  @media ${device.desktop} {
    padding: 45px 0 52px 70px;
  }
  h4 {
    font-size: 24px;
    line-height: 120%;
    @media ${device.desktop} {
      font-size: 32px;
      margin-bottom: 25px;
    }
  }

  p {
    @media ${device.desktop} {
      margin-bottom: 25px;
    }
  }

  a {
    font-weight: 600 !important;

    :before {
      display: none;
    }
  }
`

export const Number = styled.div`
  height: 28px;
  width: 28px;
  position: relative;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 33px;
  left: 0;
  font-family: "Roboto", Arial, sans-serif;
  border-radius: 50%;
  background-image: ${props => getGradient(props.theme.site)};
  font-size: 18px;
  font-weight: 500;
  color: white;
  margin: 0;

  @media ${device.desktop} {
    top: 40px;
    height: 48px;
    width: 48px;
    font-size: 30px;
  }
`

export const Body = styled.div`
  > :last-child {
    margin-bottom: 0;
  }
`
